import React from 'react'
import { observer } from 'mobx-react'
import JobViewModel from '../JobViewModel'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardTitleCount,
} from 'components/Card'
import ProgressBar from 'components/ProgressBar'
import EmptyTaskList from './EmptyTaskList'
import TaskCardTask from './TaskCardTask'
import Button from 'components/Button'
import styles from './TasksCard.sass'
import NoTaskList from './NoTaskList'

interface Props {
  vm: JobViewModel
}

export default observer(function TasksCard({ vm }: Props) {
  const taskList = vm.milestonesVM.taskLists.find(
    (tl) =>
      tl.designee.toLowerCase() ===
      vm.currentUserCollaborator?.type.toLowerCase(),
  )
  if (!taskList) {
    return null
  }

  const pendingTask = taskList.pendingTasks[0]
  const progress = (taskList.completedCount / taskList.count) * 100
  const step = (1 / taskList.count) * 100
  const title = pendingTask?.taskItem ? 'Current task' : 'All tasks completed'
  const titleCount = vm.milestonesVM.nextMilestone
    ? `(${taskList.completedCount} of ${taskList.count})`
    : ''

  if (!vm.milestonesVM.milestones.length) {
    return (
      <Card dataTest="current-task-new">
        <CardHeader compactBottomPadding>
          <CardTitle dataTest="current-task-title-new">Current task</CardTitle>
        </CardHeader>
        <CardContent>
          <NoTaskList />
        </CardContent>
        {vm.canCloseAsCollaborator && (
          <CardContent>
            <Button
              dataTest="complete-job-new"
              className={styles.completeButton}
              onClick={vm.requestCloseAsCollaborator}
            >
              Complete Job
            </Button>
          </CardContent>
        )}
      </Card>
    )
  }

  return (
    <Card dataTest="current-task-new">
      <CardHeader>
        <CardTitle dataTest="current-task-title-new">
          {title}
          <CardTitleCount>{titleCount}</CardTitleCount>
        </CardTitle>
      </CardHeader>

      <CardContent>
        {!pendingTask && [
          <ProgressBar key={1} bars={[{ progress: 100 }]} />,
          <EmptyTaskList key={2} />,
        ]}

        {pendingTask && [
          <ProgressBar
            key={1}
            bars={[{ progress }, { progress: step, style: 'striped' }]}
          />,
          <TaskCardTask key={2} item={pendingTask} />,
        ]}
      </CardContent>
      {!pendingTask && vm.canCloseAsCollaborator && (
        <CardContent>
          <Button
            dataTest="complete-job-new"
            className={styles.completeButton}
            onClick={vm.requestCloseAsCollaborator}
          >
            Complete Job
          </Button>
        </CardContent>
      )}
    </Card>
  )
})
